import { LongText } from '@dfl/mui-react-common';
import { PlaceOutlined } from '@mui/icons-material';
import { Stack } from '@mui/material';
import { IAddress } from 'lib/dfl-address-form-mui/interfaces';
import { ComponentType, memo, useMemo } from 'react';
import { getAddress } from 'utils/get-address';

type Props = {
  address: IAddress | undefined;
  lineClamp?: number;
  icon?: ComponentType;
  hideIcon?: boolean;
};

const FormattedAddressCell = ({ address, lineClamp = 3, hideIcon, icon }: Props) => {
  const IconComponent = icon || PlaceOutlined;

  const _formattedAddress = useMemo(() => {
    return address?.formattedAddress || getAddress(address);
  }, [address]);

  return (
    <Stack flexDirection={'row'} alignItems={'center'} gap={1}>
      {!hideIcon && <IconComponent fontSize={'small'} />}
      <LongText text={address?.formattedAddress || _formattedAddress} lineClamp={lineClamp} />
    </Stack>
  );
};

export default memo(FormattedAddressCell);
